import { useMemo } from 'react';
import { useCurrentUserAccess } from '../../../shared/session/useCurrentUserRole';
import { useOrganizationModulesConfig } from '../../../shared/session/useOrganizationModulesConfig';
import { getAccessibleApplicationModulesForRole } from '../../../app/router/routeManifest';

export * from '../../../app/router/routeManifest';

export const useCurrentRoleApplicationAccess = () => {
  const { data: access, isLoading: isRoleLoading, error: roleError } = useCurrentUserAccess();
  const { data: organizationApplications = [], isLoading: isApplicationsLoading, error: applicationsError } =
    useOrganizationModulesConfig();
  const userRole = access?.role || null;
  const userAccess = access
    ? {
        role: access.role,
        workspaceAccess: access.workspaceAccess,
        platformTier: access.platformTier,
        isSuperadmin: access.isSuperadmin,
        roleId: access.roleId,
        profileId: access.profileId,
        organizationId: access.organizationId,
      }
    : null;

  const accessibleModules = useMemo(
    () => getAccessibleApplicationModulesForRole(userRole, organizationApplications),
    [userRole, organizationApplications]
  );

  return {
    userRole,
    userAccess,
    organizationApplications,
    accessibleModules,
    isLoading: isRoleLoading || isApplicationsLoading,
    error: roleError || applicationsError || null,
  };
};
